import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wxmnusopoqcqxmchvdjd.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind4bW51c29wb3FjcXhtY2h2ZGpkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0MTc0MjksImV4cCI6MjA5Nzk5MzQyOX0.s0IuuWRaSNBIEcvwc9_mxTB1FpfgZ3ekrJhfKlX3ZQA'

export const supabase = createClient(supabaseUrl, supabaseKey)